import { RootState } from '../store'

export const selectExistingControls = (state: RootState) =>
  state.existingControl.existingControls

export const selectLoading = (state: RootState) => state.existingControl.loading

export const selectError = (state: RootState) => state.existingControl.error
export const selectMaturityRateResponse = (state: RootState) =>
  state.existingControl.maturityRateResponse
export const selectMaturityRates = (state: RootState) =>
  state.existingControl.maturityRateResponse?.data || []
